<template>
    <!-- 对话框 -->
    <el-drawer title="添加司机推广码" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">

        <!-- 基本信息表单 -->
        <div class="form-box">


            <template>

                <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">



                    <el-form-item label="绑定手机号:" label-width='120px' style="margin-bottom: 0">
                        <el-input v-model="submit_data.driver_phone" :placeholder="submit_rules.driver_phone.placeholder" style="width: 150px; margin-right:5px">
                        </el-input>

                    </el-form-item>
                   

                  





                </el-form>


                <!-- 对话框底部按钮 -->
                <div style="display: flex;justify-content: center">
                    <submitBtn @onSubmitDig="onSubmitDig" :data="submit_data" :rules="submit_rules"
                               :url="submit_url" :JSON_Boolean="false"></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>

                </div>

            </template>


        </div>


    </el-drawer>
</template>

<script>

    var _this;
    export default {
        props: {
            'isShow': Boolean,
            'data':''
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;
                console.log();
                 _this.submit_data.work_plate_code = _this.data;

            }
        },
        data() {
            return {


                show: false,
               


                submit_url: '/driver/bingWorkPlate',
                // 表单数据
                submit_data: {
                  
                    driver_phone: '',
                    work_plate_code: ''
                  

                },

                submit_rules: {

                
                    driver_phone: {
                        placeholder: '绑定手机号',
                        rules: {
                            required: true,
                            message: '绑定手机号为11位手机号',
                            regulation: 'eq_num',
                            rulesData: 11
                        }
                    }
                   
                },

            };
        },
        created() {

            _this = this;

        },
        methods: {


            // 关闭方法
            closeDialog() {
                _this.show = false;
                for (const key in _this.submit_data) {
                    _this.submit_data[key] = '';
                }
              

            },

          


            // 提交
            onSubmitDig() {
                _this.$emit('onSubmit');
                _this.closeDialog();
            }
        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

 
</style>
